import Select, { SelectProps } from '@/library/components/form/inputs/select';
import IconSelect, { IconSelectProps } from '@/library/components/form/inputs/select/icon-select';
import { GroupBase, OptionsOrGroups, Props } from 'react-select';
import { OptionsRequestParams } from '@/library/components/form/inputs/select/types';

type BaseCollectionFilterProps<Option> = {
  memoizedRequestParams: OptionsRequestParams;
  value: string | null;
  onChange: (value: string | null) => void;
} & SelectProps<Option>;

export type CollectionFilterProps<Option> =
  | (BaseCollectionFilterProps<Option> & { icon?: undefined }) // when there's no icon
  | (BaseCollectionFilterProps<Option> & IconSelectProps); // when the icon is provided

type Option = { id: string; label: string };

function ChatFilterSelector({
  memoizedRequestParams,
  value,
  icon,
  onChange,
  ...rest
}: Omit<Props<Option>, 'value'> & CollectionFilterProps<Option>) {
  const CollectionFilterComponent = icon ? IconSelect : Select;

  const defaultChatOptions: OptionsOrGroups<Option, GroupBase<Option>> = [
    { label: 'No Messages', id: 'no_messages' },
    { label: 'Unread Messages', id: 'unread_messages' },
    { label: 'With Messages', id: 'with_messages' },
    { label: 'Unread Mentions', id: 'mentions_unread' },
    { label: 'Read Mentions', id: 'mentions_read' }
  ] as const;

  return (
    <CollectionFilterComponent
      placeholder="Select value"
      icon={icon ? icon : ''}
      autoFocus={true}
      value={value as unknown as Option[]} // Type assertion to make TypeScript happy
      onChange={selected => {
        const selectedValue = selected as Option | null;

        onChange(selectedValue ? selectedValue.id : null);
      }}
      memoizedRequestParams={memoizedRequestParams}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.label}
      isAsync={false}
      isMulti={false}
      options={defaultChatOptions}
      {...rest}
    />
  );
}

export default ChatFilterSelector;
